
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  createdAt: 'createdAt',
  wallet: 'wallet',
  optInMarketing: 'optInMarketing'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.UserPlanScalarFieldEnum = {
  userId: 'userId',
  plan: 'plan',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionId: 'subscriptionId',
  stripeCustomerId: 'stripeCustomerId',
  cancelPeriodEnd: 'cancelPeriodEnd'
};

exports.Prisma.UserMetadataScalarFieldEnum = {
  userId: 'userId',
  workRole: 'workRole',
  experienceWithWorkflowAutomation: 'experienceWithWorkflowAutomation',
  workflowsToBuild: 'workflowsToBuild'
};

exports.Prisma.ServiceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  ownerId: 'ownerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  descriptionShort: 'descriptionShort',
  activeImplementationId: 'activeImplementationId',
  requestPermissionState: 'requestPermissionState',
  requestPermissionList: 'requestPermissionList',
  isDeleted: 'isDeleted',
  deletedAt: 'deletedAt',
  tags: 'tags',
  scheduleType: 'scheduleType',
  isTemplate: 'isTemplate',
  placeholderId: 'placeholderId'
};

exports.Prisma.ImplementationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  serviceFile: 'serviceFile',
  envVariables: 'envVariables',
  requirements: 'requirements',
  openapiSpec: 'openapiSpec',
  openapi: 'openapi'
};

exports.Prisma.ServiceToImplementationScalarFieldEnum = {
  serviceId: 'serviceId',
  implementationId: 'implementationId',
  parentImplementationId: 'parentImplementationId',
  createdAt: 'createdAt'
};

exports.Prisma.ServiceLogScalarFieldEnum = {
  id: 'id',
  serviceId: 'serviceId',
  requestId: 'requestId',
  createdAt: 'createdAt',
  level: 'level',
  source: 'source',
  event: 'event',
  rawText: 'rawText'
};

exports.Prisma.RequestScalarFieldEnum = {
  id: 'id',
  correlationId: 'correlationId',
  userId: 'userId',
  createdAt: 'createdAt',
  serviceId: 'serviceId',
  implementationId: 'implementationId',
  startedAt: 'startedAt',
  requestHeaders: 'requestHeaders',
  requestBody: 'requestBody',
  requestJson: 'requestJson',
  requestUrl: 'requestUrl',
  completedAt: 'completedAt',
  responseStatus: 'responseStatus',
  responseHeaders: 'responseHeaders',
  responseBody: 'responseBody',
  responseJson: 'responseJson',
  expiresAt: 'expiresAt',
  scheduledRequestId: 'scheduledRequestId',
  serviceCost: 'serviceCost',
  platformCost: 'platformCost',
  responseContent: 'responseContent'
};

exports.Prisma.APIKeyScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  key: 'key',
  createdAt: 'createdAt'
};

exports.Prisma.OTAPIKeyScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  key: 'key',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  clientId: 'clientId'
};

exports.Prisma.ScheduledRequestScalarFieldEnum = {
  id: 'id',
  active: 'active',
  userId: 'userId',
  createdAt: 'createdAt',
  serviceId: 'serviceId',
  method: 'method',
  path: 'path',
  bodyJson: 'bodyJson',
  scheduleExpression: 'scheduleExpression',
  scheduleArn: 'scheduleArn',
  emailOnCompletion: 'emailOnCompletion'
};

exports.Prisma.SecretScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  value: 'value',
  type: 'type',
  connectionId: 'connectionId'
};

exports.Prisma.FavoritedWorkflowScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  serviceId: 'serviceId',
  createdAt: 'createdAt'
};

exports.Prisma.FeedbackScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rating: 'rating',
  review: 'review',
  requestId: 'requestId',
  userId: 'userId'
};

exports.Prisma.ServicePlaceholderScalarFieldEnum = {
  id: 'id',
  serviceId: 'serviceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ClientScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  name: 'name',
  clientSecret: 'clientSecret',
  redirectUris: 'redirectUris',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.AuthorizationCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  clientId: 'clientId',
  userId: 'userId',
  redirectUri: 'redirectUri',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Plan = exports.$Enums.Plan = {
  FREE: 'FREE',
  STARTER: 'STARTER',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE'
};

exports.ShareableState = exports.$Enums.ShareableState = {
  PRIVATE: 'PRIVATE',
  USER_ALLOWLIST: 'USER_ALLOWLIST',
  PUBLIC: 'PUBLIC'
};

exports.ScheduleType = exports.$Enums.ScheduleType = {
  ScheduleFriendly: 'ScheduleFriendly',
  ScheduleOnly: 'ScheduleOnly'
};

exports.SecretType = exports.$Enums.SecretType = {
  USER: 'USER',
  NANGO: 'NANGO',
  PIPEDREAM: 'PIPEDREAM'
};

exports.FeedbackRating = exports.$Enums.FeedbackRating = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  UserPlan: 'UserPlan',
  UserMetadata: 'UserMetadata',
  Service: 'Service',
  Implementation: 'Implementation',
  ServiceToImplementation: 'ServiceToImplementation',
  ServiceLog: 'ServiceLog',
  Request: 'Request',
  APIKey: 'APIKey',
  OTAPIKey: 'OTAPIKey',
  ScheduledRequest: 'ScheduledRequest',
  Secret: 'Secret',
  FavoritedWorkflow: 'FavoritedWorkflow',
  Feedback: 'Feedback',
  ServicePlaceholder: 'ServicePlaceholder',
  Client: 'Client',
  AuthorizationCode: 'AuthorizationCode'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
